import React, { useState, useEffect } from 'react';

import { FaArrowUp } from 'react-icons/fa6';

const ScrollTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) { // Adjust the number (300) to show the button after scrolling a certain distance
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up the event listener when the component unmounts
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {visible && (
        <button 
          onClick={scrollToTop} 
          style={styles.scrollButton}
          aria-label="Scroll to top"
        >
        <FaArrowUp />
        </button>
      )}
    </>
  );
};

const styles = {
  scrollButton: {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    backgroundColor: 'transparent', // Make button background transparent
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    zIndex: 1000,
    transition: 'opacity 0.3s ease',
  },
  icon: {
    width: '40px', // Adjust the size of the bus icon
    height: '40px',
  },
};

export default ScrollTop;
